import { isClient } from '@/composables/useSSR'

// Before matomo.js loads, _paq is a plain array; afterwards Matomo replaces it
// with a TrackerProxy object that still exposes push(). Accept both — an
// Array.isArray guard here silently dropped every event once the tracker
// had loaded.
type MatomoQueue = { push: (event: unknown[]) => void }

function getQueue(): MatomoQueue | null {
  if (!isClient) return null
  const win = window as unknown as { _paq?: MatomoQueue }
  // Canonical Matomo pattern: seed the queue so events survive a pre-init
  // race. Inert when tracking is disabled (vue-matomo never consumes it).
  const paq: MatomoQueue = win._paq ?? ([] as unknown[][])
  win._paq = paq
  return typeof paq.push === 'function' ? paq : null
}

export function useMatomo() {
  const trackEvent = (category: string, action: string, name?: string, value?: number): void => {
    const paq = getQueue()
    if (!paq) return
    const event: unknown[] = ['trackEvent', category, action]
    if (name !== undefined) event.push(name)
    if (value !== undefined) event.push(value)
    paq.push(event)
  }

  return { trackEvent }
}
